import { Component, Inject, Renderer2, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ToolSettingsService } from 'src/app/service/tool-settings/tool-settings.service';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { UsersService } from 'src/app/service/users/users.service';
import { CurrencyPipe } from '@angular/common';
import { Location } from '@angular/common';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { ToolTransferService } from '../tool-transfer/tool-transfer.service';
import { ToolFormComponent } from '../shared/tool-form/tool-form.component';
import { forkJoin } from 'rxjs';
import { StatesService } from 'src/app/service/states/states.service';
import { Subscription } from 'rxjs';
import { MediaService } from 'src/app/service/media/media.service';
import { DialogService } from 'src/app/service/dialog/dialog.service';
import { ToolPermissionsService } from 'src/app/service/auth/tool-permissions.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';



@Component({
  selector: 'app-tool-page',
  templateUrl: './tool-page.component.html',
  styleUrls: ['./tool-page.component.scss'],
})
export class ToolPageComponent extends ToolFormComponent implements OnInit {
  @ViewChild('maintenanceRequired') maintenanceRequired;
  @ViewChild('inspectionRequired') inspectionRequired;

  subscription: Subscription;
  statesData;
  saveInProgress: boolean = false;
  modelError: boolean = false;
  redirectBack: boolean = false;
  shopOriginationIdError: boolean = false;
  errors: Array<any> = [];
  vehiclePayload: any = {};
  shopLocations: any = [];
  constructor(
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    public currencyPipe: CurrencyPipe,
    public location: Location,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public toastService: ToastService,
    public toolsService: ToolsService,
    private toolSettingsService: ToolSettingsService,
    private statesServices: StatesService,
    private usersService: UsersService,
    private toolTransferService: ToolTransferService,
    public mediaService: MediaService,
    private momentService: MomentService,
    public dialogService: DialogService,
    public toolPermissionService: ToolPermissionsService,
  ) {
    super(
      'tools',
      _document,
      renderer2,
      location,
      currencyPipe,
      activatedRoute,
      router,
      toolsService,
      toastService,
      mediaService,
      dialogService,
      toolPermissionService,
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.addTab('history', 'Tool History');
    this.subscription = this.toolTransferService.submitSubscriber.subscribe(({ next }) => {
      next && this.fetch();
    });

    this.dataModel = {
      model: {
        modelYear: '',
      },
    };

    this.fetch();
  }

  deleteToolOnNavigation(id: string) {
    if (this.payloadModel.status && this.payloadModel.status === 'Draft' && id) {
      this.toolsService.delete[this.dataType](id).subscribe(res => { });
    }
  }

  fetch() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      const id = +params.get('id');
      this.toolsService.readById[this.dataType](id).subscribe(res => {
        this.fetchSuccess(res);
      });
    });
  }

  getInventoriedDateString() {
    const inventoryDate = this.payloadModel.inventoriedDate
    if (!inventoryDate) return ''

    return this.momentService.formateDate(inventoryDate, 'MM/DD/YYYY');
  }

  updatePayload(field: string, data) {
    this.setPayload(field, data.required);
  }

  updateVehiclePayload(field: string, data) {
    this.setVehiclePayload(field, data.required);
  }

  fetchModel(tool: any, changeModel: boolean = false) {
    const isObject = typeof tool === 'object';
    const id = isObject ? (tool.model ? tool.model.id : null) : tool;

    if (!id) return;

    this.toolsService.readById['models'](id).subscribe(res => {
      const { data } = res;

      this.resetToolMedia();
      this.populateToolModelData({ model: data, tool }, changeModel);
    });
  }

  resetToolMedia() {
    this.dataModel.images =
      this.dataModel.images && this.dataModel.images.length > 0
        ? this.dataModel.images.filter(image => image.parentType === 'tools')
        : [];
    this.dataModel.documents =
      this.dataModel.documents && this.dataModel.documents.length > 0
        ? this.dataModel.images.filter(image => image.parentType === 'tools')
        : [];
  }

  fetchSuccess(res: any) {
    this.populatePayloadModel(res);
    this.populateVehiclePayload(res);
    this.populateDataModel(res);
    this.fetchOthers();

    if (res.data.assignmentId) this.fetchAssignment(res.data.assignmentId);
  }

  fetchAssignment(assignmentId: number) {
    this.toolSettingsService.read['assignment'](assignmentId).subscribe(res => {
      this.dataModel.assignment = res.data;
      res.data.job ? (this.dataModel.assignment.job.alias = res.data.job.job_number + ' ' + res.data.job.name) : '';
    });
  }

  fetchOthers() {
    const requests = [
      this.toolsService.list['models']({ 'scope[assetClassesByStatus]': 1 }),
      this.toolsService.list['vendors']({ order: 'vendorId', limit: 100000 }),
      this.usersService.getUsers({
        hub_access: 'true',
      }),
      this.statesServices.getStates(),
      this.toolsService.list['shops']({ 'scope[hardShops]': true }),
    ];

    forkJoin(requests).subscribe(
      res => {
        if (this.models?.length !== res[0]?.data?.length) {
          this.models = res[0].data;
        }

        if (this.vendors?.length !== res[1]?.length) {
          this.vendors = res[1].data
        }

        // Description is reset to empty thing
        if (this.employees?.length !== res[2].data?.length) {
          this.employees = res[2].data;
        }

        if (this.statesData?.length !== res[3].data?.length) {
          this.statesData = res[3].data;
        }

        if (this.shopLocations?.length !== res[4].data?.length) {
          this.shopLocations = res[4].data;
        }

        this.loadSelect2();
        this.loadDatePicker();
      },
      error => {
        console.error(error);
      },
    );
  }

  setVehiclePayload(field: string, value: unknown) {
    this.vehiclePayload[field] = value;
  }

  async saveEvent(redirectBack: boolean) {
    await this.handleSave(redirectBack).catch(console.error);
  }

  getErrorMsg(field: string) {
    const potentialError = this.errors.find(error => error.message.includes(field));

    if (!potentialError?.message) return;

    return potentialError.message;
  }

  async handleSave(redirectBack: boolean = false) {
    this.submitted = true;
    this.redirectBack = redirectBack;
    const vehiclePayload = this.getVehiclePayload();
    this.errors = [];

    return new Promise((resolve, reject) => {
      if (!this.payloadModel.shopOriginationId) {
        this.shopOriginationIdError = true;
        return false;
      }
      if (!this.payloadModel.toolModelId) {
        this.modelError = true;
        return false;
      }

      this.modelError = false;
      this.shopOriginationIdError = false;
      const payload = this.getPayload();
      if (this.vehiclePayload.id) {
        this.updateVehicle(vehiclePayload, this.vehiclePayload.id)
          .then(() => {
            this.errors = [];
            this.updateTool(payload, redirectBack)
              .then(() => {
                if (redirectBack) this.navigateBack();
                resolve(true);
              })
              .catch(err => {
                reject(err);
              });
          })
          .catch(err => {
            reject(err);
          });

        return;
      }
      if (this.dataModel.model.allowVehicleDetails) {
        this.createVehicle(vehiclePayload)
          .then((res: any) => {
            this.errors = [];
            this.vehiclePayload.id = res.data.id;
            this.updateTool(payload, redirectBack)
              .then(() => {
                if (redirectBack) this.navigateBack();
                resolve(true);
              })
              .catch(err => {
                reject(err);
              });
          })
          .catch(err => {
            reject(err);
          });

        return;
      }
      this.updateTool(payload, redirectBack)
        .then(() => {
          if (redirectBack) this.navigateBack();
          resolve(true);
        })
        .catch(err => {
          this.shopOriginationIdError = true;
          reject(err);
        });
    });
  }

  updateVehicle(data, vehicleId: string) {
    return new Promise((resolve, reject) => {
      this.toolSettingsService.update['vehicle_details'](data, vehicleId).subscribe(
        res => {
          resolve(res);
        },
        error => {
          error.error.errors.forEach(element => {
            this.errors.push(element);
            this.toastService.showToast(element.message, 'error');
            reject(error);
          });
        },
      );
    });
  }

  createVehicle(vehiclePayload) {
    return new Promise((resolve, reject) => {
      this.toolSettingsService.create['vehicle_details'](vehiclePayload).subscribe(
        res => {
          resolve(res);
        },
        error => {
          error.error.errors.forEach(element => {
            this.errors.push(element);
            this.toastService.showToast(element.message, 'error');
            reject(error);
          });
        },
      );
    });
  }

  updateTool(payload, redirectBack) {
    return new Promise((resolve, reject) => {
      this.updatePromise(payload, redirectBack)
        .then(() => {
          resolve(true);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  handleAlertAction(data: any) {
    if (!data?.message) {
      this.toastService.showToast('Please enter alert message to enable', 'error');
      return;
    }

    if (!this.dataModel.alert.id && !this.saveInProgress) {
      this.saveInProgress = true;
      return this.saveAlert(data);
    }
    setTimeout(() => {
      this.updateAlert(data);
    }, 500);
  }

  async handleTransfer() {
    try {
      await this.handleSave(false);
      this.toolTransferService.transfer({
        ...this.payloadModel,
        ...this.dataModel,
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleCancel() {
    if (this.payloadModel.status !== 'Draft') {
      this.navigateBack();
      return;
    }

    const params = { draftCancel: true };
    this.toolsService.delete[this.dataType](this.dataModel.id, params).subscribe(() => {
      this.navigateBack();
    });
  }

  create(redirectBack: boolean) {
    this.toolsService.create[this.dataType](this.dataModel).subscribe(
      res => {
        if (redirectBack) this.navigateBack();
      },
      error => {
        console.error(error);
      },
    );
  }

  saveAlert(data: any) {
    const payload = {
      toolId: this.dataModel.id,
      message: data.message,
      enabled: data.enabled,
    };
    this.toolSettingsService.create['alert'](payload).subscribe(res => {
      this.dataModel.alert = res.data;
      this.toastService.showToast(res.message, 'success');
      this.saveInProgress = false;
    });
  }

  updateAlert(data: any) {
    const payload = {
      id: this.dataModel.alert.id,
      data: {
        toolId: this.dataModel.id,
        message: data.message,
        enabled: data.enabled,
      },
    };
    this.toolSettingsService.update['alert'](payload).subscribe(res => {
      this.toastService.showToast(res.message, 'success');
    });
  }

  populatePayloadModel(res: any) {
    const { data } = res;
    this.data = data;

    this.payloadModel.shopOriginationId = data.shopOriginationId || null;
    this.payloadModel.serialNumber = data.serialNumber || null;
    this.payloadModel.assetId = data.assetId || null;
    this.payloadModel.initialMileageHours = data.initialMileageHours || 0;
    this.payloadModel.lastMileageHours = data.lastMileageHours || 0;
    this.payloadModel.maintenanceRequired = data.maintenanceRequired;
    this.payloadModel.inspectionRequired = data.inspectionRequired;
    this.payloadModel.notes = data.notes || null;
    this.payloadModel.purchDate = data.purchDate || null;
    this.payloadModel.purchNote = data.purchNote || null;
    this.payloadModel.purchPrice = data.purchPrice || '';
    this.payloadModel.purchBy = data.purchBy || 0;
    this.payloadModel.purchWarrantyExpiration = data.purchWarrantyExpiration || '';
    this.payloadModel.purchPoNumber = data.purchPoNumber || '';
    this.payloadModel.purchVendor = data.purchVendor || 0;
    this.payloadModel.assignmentId = data.assignmentId || null;
    this.payloadModel.status = data.status || '';
    this.payloadModel.assignmentType =
      data.assignment && data.assignment.type ? data.assignment.type.name : 'Available';

    const hasInventory = !!data?.inventory?.length

    this.payloadModel.inventoriedDate = ''

    if (hasInventory) {
      const latestInventoryRecord = data.inventory[data.inventory.length - 1]
      this.payloadModel.inventoriedDate = latestInventoryRecord.toolInventory.inventoriedDate
    }

    this.payloadModel.documents =
      data.documents && data.documents.length > 0
        ? data.documents.filter(document => document.category === 'document')
        : [];
    this.payloadModel.images =
      data.images && data.images.length > 0 ? data.images.filter(image => image.category === 'image') : [];

    this.formatToCurrency('purchPrice');
    this.payloadModel.inspectionDate = data.inspectionDate;
  }

  formatToCurrencyGeneric(property: string, event: any = null) {
    if (event) {
      this.vehiclePayload[property] = this.removeCurrencyData(this.formattedValue[property]);
    }
    if (this.vehiclePayload[property]) {
      this.formattedValue[property] = this.currencyPipe.transform(
        parseFloat(this.vehiclePayload[property].toString()),
        '$ ',
      );
      return;
    }
    this.formattedValue[property] = '';
  }

  formatToCommaSeperatedNumber(property: string, event: any = null) {
    if (event) {
      this.vehiclePayload[property] = parseInt(this.formattedValue[property]);
    }
    if (this.vehiclePayload[property]) {
      this.formattedValue[property] = this.vehiclePayload[property].toLocaleString();
      return;
    }

    this.formattedValue[property] = '';
  }

  populateVehiclePayload(res: any) {
    const { data } = res;

    this.vehiclePayload.toolId = data.id;
    this.vehiclePayload.id = data.vehicleDetail ? data.vehicleDetail.id : null;
    this.vehiclePayload.licensePlate = data.vehicleDetail?.licensePlate || '';
    this.vehiclePayload.state = data.vehicleDetail ? data.vehicleDetail.state : '';
    this.vehiclePayload.warrantyExpirationDate = data.vehicleDetail
      ? data.vehicleDetail.warrantyExpirationDate || null
      : null;
    this.vehiclePayload.tabExpirationDate = data.vehicleDetail ? data.vehicleDetail.tabExpirationDate || null : null;
    this.vehiclePayload.tabRenewalAmount = data.vehicleDetail ? data.vehicleDetail.tabRenewalAmount || null : null;
    this.vehiclePayload.hasInsurance = data.vehicleDetail ? data.vehicleDetail.hasInsurance || false : null;
    this.vehiclePayload.insuranceDate = data.vehicleDetail ? data.vehicleDetail.insuranceDate || null : null;
    this.vehiclePayload.warrantyExpirationMileage = data.vehicleDetail
      ? data.vehicleDetail.warrantyExpirationMileage || null
      : null;
    this.vehiclePayload.powertrainExpirationDate = data.vehicleDetail
      ? data.vehicleDetail.powertrainExpirationDate || null
      : null;
    this.vehiclePayload.powertrainExpirationMileage = data.vehicleDetail
      ? data.vehicleDetail.powertrainExpirationMileage || null
      : null;
    this.vehiclePayload.emissionsExpirationDate = data.vehicleDetail
      ? data.vehicleDetail.emissionsExpirationDate || null
      : null;
    this.vehiclePayload.emissionsExpirationMileage = data.vehicleDetail
      ? data.vehicleDetail.emissionsExpirationMileage || null
      : null;
    this.vehiclePayload.notes = data.vehicleDetail ? data.vehicleDetail.notes || null : null;
    this.vehiclePayload.fleetVehicleNumber = data.vehicleDetail ? data.vehicleDetail.fleetVehicleNumber || null : null;
    this.formatToCurrencyGeneric('tabRenewalAmount');
    this.formatToCommaSeperatedNumber('warrantyExpirationMileage');
    this.formatToCommaSeperatedNumber('powertrainExpirationMileage');
    this.formatToCommaSeperatedNumber('emissionsExpirationMileage');
  }

  populateDataModel(res: any) {
    const { data, meta } = res;

    this.dataModel.id = data.id;
    this.dataModel.status = data.status;
    this.dataModel.toolId = data.toolId;
    this.dataModel.images = data.images || [];
    this.dataModel.documents = data.documents || [];
    this.dataModel.alert = data.alert || { enabled: false };
    this.dataModel.meta = meta || null;

    this.fetchModel(data);
  }

  populateToolModelData(data: any, changeModel: boolean = false) {
    const { model, tool } = data;

    this.payloadModel.toolModelId = model.id;
    this.payloadModel.shopOriginationId = tool.shopOriginationId;
    this.dataModel.model = model;
    this.dataModel.model.maintenance = this.getNestedAsset(model.maintenance)
    this.dataModel.model.inspection = this.getNestedAsset(model.inspection)

    changeModel ? this.updateMaintenaceAndInspection(model) : this.populateMaintenaceAndInspection(model);
    this.populatePayloadDescription({ model, tool });
    this.populateModelImageAndDocs(model);
  }

  getNestedAsset(assetData: unknown[]) {
    const hasAssets = Array.isArray(assetData) && assetData?.length

    if (!hasAssets) return []

    return assetData.map(el => el.media)
  }

  updateMaintenaceAndInspection(model) {
    this.maintenanceRequired.updateVal(model.maintenanceRequired);
    this.inspectionRequired.updateVal(model.inspectionRequired);
    this.payloadModel.maintenanceRequired = model.maintenanceRequired;
    this.payloadModel.inspectionRequired = model.inspectionRequired;
  }

  populateMaintenaceAndInspection(model) {
    const x = !!this.dataModel.model && this.payloadModel.status === 'Draft';

    x
      ? this.maintenanceRequired.updateVal(model.maintenanceRequired)
      : this.maintenanceRequired.updateVal(this.payloadModel.maintenanceRequired);

    x
      ? this.inspectionRequired.updateVal(model.inspectionRequired)
      : this.inspectionRequired.updateVal(this.payloadModel.inspectionRequired);
  }

  populateModelImageAndDocs(model) {
    this.dataModel.images = this.getNestedAsset(model.images)
    this.dataModel.documents = this.getNestedAsset(model.documents)

    this.payloadModel.images = [...this.payloadModel.images, ...this.dataModel.images];
    this.payloadModel.documents = [...this.payloadModel.documents, ...this.dataModel.documents];
  }

  populatePayloadDescription(data: any) {
    const { tool, model } = data;
    this.payloadModel.description = tool
      ? tool.description
        ? tool.description
        : model.description
      : model.description;
  }

  getVehiclePayload() {
    return {
      toolId: this.vehiclePayload.toolId,
      fleetVehicleNumber: this.vehiclePayload?.fleetVehicleNumber || '',
      ...(this.vehiclePayload.licensePlate && {
        licensePlate: this.vehiclePayload.licensePlate,
      }),
      ...(this.vehiclePayload.state && { state: this.vehiclePayload.state }),
      ...(this.vehiclePayload.warrantyExpirationDate && {
        warrantyExpirationDate: this.vehiclePayload.warrantyExpirationDate,
      }),
      ...(this.vehiclePayload.tabExpirationDate && {
        tabExpirationDate: this.vehiclePayload.tabExpirationDate,
      }),
      ...(this.vehiclePayload.tabRenewalAmount && {
        tabRenewalAmount: this.vehiclePayload.tabRenewalAmount,
      }),
      ...(this.vehiclePayload.hasInsurance && {
        hasInsurance: this.vehiclePayload.hasInsurance,
      }),
      ...(this.vehiclePayload.insuranceDate && {
        insuranceDate: this.vehiclePayload.insuranceDate,
      }),
      ...(this.vehiclePayload.warrantyExpirationMileage && {
        warrantyExpirationMileage: this.vehiclePayload.warrantyExpirationMileage,
      }),
      ...(this.vehiclePayload.powertrainExpirationDate && {
        powertrainExpirationDate: this.vehiclePayload.powertrainExpirationDate,
      }),
      ...(this.vehiclePayload.powertrainExpirationMileage && {
        powertrainExpirationMileage: this.vehiclePayload.powertrainExpirationMileage,
      }),
      ...(this.vehiclePayload.emissionsExpirationDate && {
        emissionsExpirationDate: this.vehiclePayload.emissionsExpirationDate,
      }),
      ...(this.vehiclePayload.emissionsExpirationMileage && {
        emissionsExpirationMileage: this.vehiclePayload.emissionsExpirationMileage,
      }),
      ...(this.vehiclePayload.notes && { notes: this.vehiclePayload.notes }),
      ...(this.vehiclePayload.fleetVehicleNumber && {
        fleetVehicleNumber: this.vehiclePayload.fleetVehicleNumber,
      }),
    };
  }

  validateNumber(event) {
    var regex = new RegExp('^[0-9-!@#$%*?]');
    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  getPayload() {
    // every time it's saving it should save as tool as published
    this.payloadModel.status = 'Published';

    return {
      ...(this.payloadModel.description && {
        description: this.payloadModel.description,
      }),
      shopOriginationId: this.payloadModel.shopOriginationId,
      ...(this.payloadModel.shopOriginationId && {
        shopOriginationId: this.payloadModel.shopOriginationId,
      }),
      toolModelId: this.payloadModel.toolModelId,
      ...(this.payloadModel.shopOriginationId && {
        shopOriginationId: this.payloadModel.shopOriginationId,
      }),
      ...(this.payloadModel.initialMileageHours && {
        initialMileageHours: this.payloadModel.initialMileageHours,
      }),
      ...(this.payloadModel.lastMileageHours && {
        lastMileageHours: this.payloadModel.lastMileageHours,
      }),
      ...(this.payloadModel.modelYear && {
        modelYear: this.payloadModel.modelYear,
      }),
      notes: this.payloadModel.notes,
      ...(this.payloadModel.purchDate && {
        purchDate: this.payloadModel.purchDate,
      }),
      ...(this.payloadModel.purchWarrantyExpiration && {
        purchWarrantyExpiration: this.payloadModel.purchWarrantyExpiration,
      }),
      ...(this.payloadModel.purchNote && {
        purchNote: this.payloadModel.purchNote,
      }),
      ...(this.payloadModel.purchPrice && {
        purchPrice: this.payloadModel.purchPrice,
      }),
      ...(this.payloadModel.purchPoNumber && {
        purchPoNumber: this.payloadModel.purchPoNumber,
      }),
      ...(this.payloadModel.purchBy && { purchBy: this.payloadModel.purchBy }),
      ...(this.payloadModel.purchVendor && {
        purchVendor: this.payloadModel.purchVendor,
      }),
      serialNumber: this.payloadModel.serialNumber,
      assetId: this.payloadModel.assetId,
      status: this.payloadModel.status,
      maintenanceRequired: this.payloadModel.maintenanceRequired,
      inspectionRequired: this.payloadModel.inspectionRequired,
      ...(this.payloadModel.inspectionRequired && {
        inspectionDate: this.payloadModel.inspectionDate === '' ? null : this.payloadModel.inspectionDate,
      }),
    };
  }

  handleImageError() {
    // Handle the error by setting a fallback image source
    this.dataModel.model.thumbnail.url = '/assets/images/image-not-found.jpg';
  }

  getImageLink() {
    const thumb = this.dataModel?.model?.thumbnail
    const hasMultipleImages = Array.isArray(thumb) && thumb?.length

    if (hasMultipleImages) {
      return this.dataModel?.model.thumbnail[0].url
    }

    return this.dataModel?.model?.thumbnail?.url ?? '/assets/images/image-not-found.jpg'
  }
}
